export const ACCOUNT_ROUTES_LIST = {
  INDEX: '/admin/billing/account',
  ADD_PAYMENT: '/admin/billing/account/payment',
  SWITCH_PLAN: '/admin/billing/account/switch',
  PAID_ALLOWANCE: '/admin/billing/account/paid-allowance',
  PAID_ALLOWANCE_REVIEW: '/admin/billing/account/paid-allowance/review',
  PAID_ALLOWANCE_CURRENT_GOLD: '/admin/billing/account/paid-allowance/gold',
  PAYMENT_METHOD: '/admin/billing/method',
};
